import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DefaultButton from "./DefaultButton";

export function PrevNextButtons({ currentId, basePath, name }) {
    const navigate = useNavigate();
    const [previous, setPrevious] = useState(null);
    const [next, setNext] = useState(null);
    const { ids } = useSelector(store => store.nextPrev);

    useEffect(() => {
        if (!ids[name]) return;

        const list = ids[name];
        const index = list.findIndex(el => {
            // Support both plain IDs and objects { id, type }
            const id = typeof el === "object" ? el.id : el;
            return Number(id) === Number(currentId);
        });

        setPrevious(list[index - 1] ?? null);
        setNext(list[index + 1] ?? null);
    }, [ids, currentId, name]);

    // Resolve path — handles both plain IDs (uses basePath) and objects (uses type)
    const resolvePath = (item) => {
        if (!item) return null;
        if (typeof item === "object") {
            const base = item.type === "Workflow" ? "/workflow/" : "/ticketing/";
            return base + item.id;
        }
        return (basePath ?? "/") + item;
    };

    return (
        <>
            <DefaultButton
                buttonClass="default-btn-color me-1"
                buttonTitle={<i className="fas fa-arrow-left"></i>}
                actionBlock={() => navigate(resolvePath(previous))}
                disabled={!previous}
            />
            <DefaultButton
                buttonClass="default-btn-color me-1"
                buttonTitle={<i className="fas fa-arrow-right"></i>}
                actionBlock={() => navigate(resolvePath(next))}
                disabled={!next}
            />
        </>
    );
}